module.exports = __webpack_public_path__ + "img/20210803.bc9ee5f6.gif";